module.exports = __webpack_public_path__ + "static/media/icon_duration.2938a25e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_duration.svg
// module id = 461
// module chunks = 0